import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_38: DocMigration = {
  maxSchemaVersion: "0.0.38",
  apply(json: any) {
    if (json.electricalSystem) {
      for (const controllerId in json.electricalSystem.controllers) {
        const controller = json.electricalSystem.controllers[controllerId];
        if (controller.controllerType === "SWITCH" && !controller.switchType) {
          controller.switchType = "STANDARD";
        }
      }
    }
    return json;
  },
};

export default migration_0_0_38;
